import { useCallback, useEffect, useState } from 'react';
import { useParams, Link as RouterLink} from 'react-router-dom'
import { Box, Button, Chip, Divider, Link, Grid, Tab, Tabs, Typography } from '@mui/material';
import { useAuth } from '../../../hooks/use-auth';
import { useMounted } from '../../../hooks/use-mounted';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { FormationBasicDetails } from '../../../components/dashboard/formations/formation-basic-detail';
import { gtm } from '../../../lib/gtm';
import { formationsApi } from '../../../api/formation-api';
import { patientsFolderApi } from '../../../api/patients_folder-api';
import { PatientsFolderBasicDetails } from '../../../components/dashboard/patients-folder/patients-folder-basic-detail';

const tabs = [
  { label: 'Détails', value: 'details' },
  // { label: 'Statistiques', value: 'statistiques' }
];

const PatientsFolderDetails = () => {
  const {patientsFolderId} = useParams();
  const isMounted = useMounted();

  const [patientsFolder, setPatientsFolder] = useState({patients_file: {name: 10}, patients_folder_datas: []});
  const [professionsToModify, setProfessionsToModify] = useState([]);
  const [auditsToModify, setAuditsToModify] = useState([]);
  const [currentTab, setCurrentTab] = useState('details');
  const { user } = useAuth(); 

  const getPatientsFolderData = useCallback(async () => {
    try {
      const data = await patientsFolderApi.getPatientsFolderData(user.admin_id, patientsFolderId)
      if (isMounted()) {
        setPatientsFolder(data)
        // console.log(data.patients_file.epps)
        setProfessionsToModify(data.patients_file.professions)
        setAuditsToModify(data.patients_file.epps)
      }
    } catch (err) {
      console.error(err);
    }
  }, [isMounted]);

  useEffect(() => {
    getPatientsFolderData();
    gtm.push({ event: 'page_view' });
  }, []);

  const handleTabsChange = (event, value) => {
    setCurrentTab(value);
  };

  return (
    <Box
      component="main"
      sx={{
        flexGrow: 1,
        py: 11,
        mx: 3
      }}
    >
      <Box sx={{ mb: 5 }}>
        <RouterLink
          to={`/${globalThis.localStorage.getItem('tenant')}/dashboard/patients_folder`}
          style={{ textDecoration: 'none' }}
        >
          <Link
            color="textPrimary"
            component="a"
            sx={{
              alignItems: 'center',
              display: 'flex'
            }}
          >
            <ArrowBackIcon
              fontSize="small"
              sx={{ mr: 1 }}
            />
            <Typography variant="subtitle2">
              Dossier patients
            </Typography>
          </Link>
        </RouterLink>
      </Box>
      <Grid
        container
        justifyContent="space-between"
        spacing={3}
      >
        <Grid
          item
          sx={{
            alignItems: 'center',
            display: 'flex',
            overflow: 'hidden'
          }}
        >
          <div>
            <Typography variant="h4">
              {patientsFolder.patients_file.name}
            </Typography>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center'
              }}
            >
              <Typography variant="subtitle2">
                Id du fichier patients:
              </Typography>
              <Chip
                label={patientsFolderId}
                size="small"
                sx={{ ml: 1 }}
              />
            </Box>
          </div>
        </Grid>
      </Grid>
      {/* <Grid
        item
        sx={{ mt: 2, mr: 4}}
        display= 'flex'
        justifyContent="flex-end"
      > 
        <Box
          sx={{
            mr: 2,
          }}
        >
          <RouterLink
            to={`/:tenant/dashboard/session/create`}
            style={{ textDecoration: 'none' }}
            state={{
              from:`/:tenant/dashboard/patients_folder/${patientsFolderId}`,
              formationId: formationId
            }}
          >
            <Button
              variant="contained"
            >
              Créer une session
            </Button>
          </RouterLink>
        </Box>
      </Grid> */}
      <Tabs
        indicatorColor="primary"
        onChange={handleTabsChange}
        scrollButtons="auto"
        textColor="primary"
        value={currentTab}
        variant="scrollable"
        >
        {tabs.map((tab) => (
          <Tab
          key={tab.value}
          label={tab.label}
          value={tab.value}
          />
          ))}
      </Tabs>
      <Divider />
      <Box sx={{ mt: 3 }}>
        {currentTab === 'details' && (
          <Grid
            container
            spacing={3}
          >
            <Grid
              item
              xs={12}
            >
              <PatientsFolderBasicDetails
                patientsFolder = {patientsFolder}
                setPatientsFolder = {setPatientsFolder}
                professionsToModify={professionsToModify}
                setProfessionsToModify={setProfessionsToModify}
                auditsToModify={auditsToModify}
                setAuditsToModify={setAuditsToModify}
              />
            </Grid>
          </Grid>
        )}
      </Box>
    </Box>
  );
};

export default PatientsFolderDetails;
